import client, { ClientOptions } from "../client";

export type AssetObjectType = "TRANSACTION" | "EXPENSE" | "ACCOUNTING" | "REIMBURSEMENT";
export type UploadAssetType = "RECEIPT" | "PHOTO";

export interface PrepareAssetUploadInput {
  object_type: AssetObjectType;
  object_id: string;
  asset_type: UploadAssetType;
  file_name: string;
  content_type: string;
  file_size: number;
}

export interface PresignedAssetUpload {
  url: string;
  fields: Record<string, string> | string;
  key: string;
  expires_at: string;
}

export interface GetAssetUrlsInput {
  object_type: AssetObjectType;
  object_id: string;
  asset_ids?: string[];
  download?: boolean;
}

export interface AssetUrl {
  asset_id: string;
  url: string;
  expires_at: string;
}

// Ownership denials are expected here (wallet connection rules), so they reject instead of signing the user out.
const ASSET_LINK_OPTIONS: ClientOptions = { suppressErrorToast: true, rejectOnDenial: true };

export const prepareAssetUpload = (input: PrepareAssetUploadInput) => {
  return client(
    {
      query: `mutation PrepareAssetUpload($input: PrepareAssetUploadInput) {
        prepare_asset_upload(input: $input) {
          url
          fields
          key
          expires_at
        }
      }`,
      variables: { input }
    },
    ASSET_LINK_OPTIONS
  );
};

export const getAssetUrls = (input: GetAssetUrlsInput) => {
  return client(
    {
      query: `query GetAssetUrls($input: GetAssetUrlsInput) {
        get_asset_urls(input: $input) {
          asset_id
          url
          expires_at
        }
      }`,
      variables: { input }
    },
    ASSET_LINK_OPTIONS
  );
};
